import { BaseElement } from '../base-element';

export class AuthCallbackPage extends BaseElement {
  connectedCallback(): void {
    this.render(`
      <div class="flex min-h-[60vh] items-center justify-center px-6 py-10" data-testid="auth-callback-page">
        <div class="relative w-full max-w-2xl overflow-hidden rounded-[32px] border border-neutral-200 bg-white px-8 py-10 text-center shadow-[0_24px_70px_rgba(48,52,37,0.12)] dark:border-white/10 dark:bg-surface-dark">
          <div class="pointer-events-none absolute -left-12 top-0 h-32 w-32 rounded-full bg-primary-100 blur-3xl dark:bg-primary-900/25"></div>
          <div class="pointer-events-none absolute -right-8 bottom-0 h-36 w-36 rounded-full bg-secondary-100 blur-3xl dark:bg-secondary-900/20"></div>
          <div class="relative flex flex-col items-center gap-4">
            <div class="inline-flex items-center rounded-full bg-primary-100 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.18em] text-primary-700 dark:bg-primary-500/15 dark:text-primary-200">Venom Dog Sports</div>
            <dt-spinner size="large"></dt-spinner>
            <div class="space-y-2">
              <h1 class="text-2xl font-semibold text-neutral-900 dark:text-white">Finishing secure sign-in...</h1>
              <p class="mx-auto max-w-md text-sm leading-6 text-neutral-500 dark:text-neutral-400">We’re confirming your sign-in and sending you back to the app.</p>
            </div>
          </div>
        </div>
      </div>
    `);
  }
}

customElements.define('dt-auth-callback-page', AuthCallbackPage);